import './app/account.js';
import './app/adm.js';
import './app/admin.js';
import './app/auth.js';
import './app/calendar.js';
import './app/elearning.js';
import './app/filter.js';
import './app/loader.js';
import './app/plan.js';
